import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMDXComponents as _provideComponents } from "next-mdx-import-source-file";
function _createMdxContent(props) {
    const _components = Object.assign({
        p: "p",
        h2: "h2",
        ul: "ul",
        li: "li"
    }, _provideComponents(), props.components);
    return _jsxs(_Fragment, {
        children: [
            _jsx(_components.p, {
                children: 'All content available on asadatik.dev, including but not limited to text, graphics, logos, images, videos, and CV, is the property of Asaduzzaman Atik ("I," "me," "my," or "mine") and is protected by applicable copyright laws. All rights are reserved. 👍'
            }),
            "\n",
            _jsx(_components.h2, {
                children: "1. Permissible Use 📝"
            }),
            "\n",
            _jsx(_components.p, {
                children: "You may access and view the content on asadatik.dev for personal, non-commercial use only. You are permitted to:"
            }),
            "\n",
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsx(_components.li, {
                        children: "View and display the content on your computer or mobile device."
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Print or download content for your personal and non-commercial use, provided you do not modify or delete any copyright or proprietary notices."
                    }),
                    "\n"
                ]
            }),
            "\n",
            _jsx(_components.h2, {
                children: "2. Prohibited Use 🚫"
            }),
            "\n",
            _jsx(_components.p, {
                children: "Any unauthorized use, reproduction, distribution, modification, creation of derivative works, or public display of content from asadatik.dev without my explicit written permission is strictly prohibited. You may not use the content for commercial purposes or for any other use not expressly permitted in this Copyright Notice."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "3. Report Copyright Infringement 🔍"
            }),
            "\n",
            _jsx(_components.p, {
                children: "If you believe that any content on asadatik.dev infringes on your copyright or the copyright of someone you represent, please notify me at asadatik.me@gmail.com. To be effective, your copyright infringement notice must include:"
            }),
            "\n",
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsx(_components.li, {
                        children: "Identification of the copyrighted work claimed to have been infringed."
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Identification of the allegedly infringing material and its location on asadatik.dev."
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Sufficient contact information, including your name, email address, and phone number."
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "A statement that you have a good faith belief that the use of the material is not authorized by the copyright owner, its agent, or the law."
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "A statement, made under penalty of perjury, that the information in your notice is accurate, and that you are the copyright owner or authorized to act on behalf of the copyright owner."
                    }),
                    "\n"
                ]
            }),
            "\n",
            _jsx(_components.h2, {
                children: "4. Contact 📞"
            }),
            "\n",
            _jsx(_components.p, {
                children: "For any inquiries or questions regarding this Copyright Notice or any copyright-related issues on asadatik.dev, please contact me at asadatik.me@gmail.com."
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = Object.assign({}, _provideComponents(), props.components);
    return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
        children: _jsx(_createMdxContent, props)
    })) : _createMdxContent(props);
}
export default MDXContent;
